export default __webpack_public_path__ + "static/media/korchnoi.cea7aa50.jpeg";